"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var removeSpecialCharacters = function (params) {
    if (params !== null && typeof params !== 'undefined') {
        var convertToStr = params.toString();
        return convertToStr.replace(/[`!$@#^&*()_+\-=\[\]{};"\\<>?~]/gi, "-").toLowerCase();
    }
    return undefined;
};
exports.default = removeSpecialCharacters;
